export default __webpack_public_path__ + "static/media/team.c9651ef2.png";